export default __webpack_public_path__ + "imgs/Amazon_Prime_Video_logo.5ba6d548040a1f36c0901f7344513836.svg";